import { Sparkles } from "lucide-react";

/** The AI's summary of an album, for a PM. Nothing when the album has none. */
export function AlbumSummary({ summary }: { summary: string | null | undefined }) {
  if (!summary) return null;
  return (
    <section data-testid="album-summary" className="rounded-md bg-muted/50 px-3 py-2">
      <h4 className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Sparkles className="size-3.5" aria-hidden />
        AI summary
      </h4>
      <p className="mt-1 text-sm">{summary}</p>
    </section>
  );
}
